import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navItems } from '../../data/mock';
import { Button } from '../ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          className={`font-playfair text-2xl font-medium tracking-wide transition-colors duration-300 ${
            isScrolled ? 'text-charcoal' : 'text-white'
          }`}
        >
          NekedSzedtem
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className={`font-montserrat text-sm uppercase tracking-wider transition-colors duration-300 hover:text-warm-sage ${
                isScrolled ? 'text-charcoal' : 'text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
          <Button
            onClick={(e) => handleNavClick(e, '#kapcsolat')}
            className="bg-warm-sage hover:bg-warm-sage/90 text-white font-montserrat text-sm uppercase tracking-wider px-6"
          >
            Ajánlatkérés
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Menü"
        >
          {isMobileMenuOpen ? (
            <X className={`w-6 h-6 ${isScrolled ? 'text-charcoal' : 'text-white'}`} />
          ) : (
            <Menu className={`w-6 h-6 ${isScrolled ? 'text-charcoal' : 'text-white'}`} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-white shadow-lg transition-all duration-300 ${
          isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <nav className="container mx-auto px-6 py-6 flex flex-col gap-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="font-montserrat text-sm uppercase tracking-wider text-charcoal hover:text-warm-sage transition-colors py-2"
            >
              {item.label}
            </a>
          ))}
          <Button
            onClick={(e) => handleNavClick(e, '#kapcsolat')}
            className="bg-warm-sage hover:bg-warm-sage/90 text-white font-montserrat text-sm uppercase tracking-wider w-full mt-2"
          >
            Ajánlatkérés
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
